<agm-map 
  [latitude]="mapCenter.latitude"
  [longitude]="mapCenter.longitude"
  [zoom]="zoomInfo"
  [disableDefaultUI]="false"
  [zoomControl]="false"
  (mapClick)="mapClicked($event)">
    <agm-marker-cluster imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m">
        <agm-marker 
            *ngFor="let m of markers; let i = index"
            (markerClick)="clickedMarker(infoWindow, i)"
            [latitude]="m.lat"
            [longitude]="m.lng"
            [iconUrl]="m.type==='Offer' ? iconOffer : icon"
            [label] = "getHotelPrice(m.label)"
            [markerDraggable]="m.draggable"
            (dragEnd)="markerDragEnd(m, $event)">
            <agm-info-window *ngIf="hasInfoWindow" [disableAutoPan]="false" #infoWindow [isOpen]="isOpen(i)">
                <div class="infoWindow" *ngIf="selectedHotel">
                    <h2>
                        <a [routerLink]="['property', selectedHotel.title, selectedHotel.offerId]"
                            [queryParams]="{ checkInDate: requestForSearch.checkInDate, checkOutDate: requestForSearch.checkOutDate, adults: requestForSearch.adults, children: requestForSearch.children, or: requestForSearch.or, requestId: requestForSearch.requestId, hotelid: selectedHotel.offerId}">{{selectedHotel.title}}</a>
                        <span class="stars">
                            <span *ngFor="let star of getStars(selectedHotel.stars)" class="icon icon-star"></span>
                            <span class="icon icon-star"></span>
                            <span class="icon icon-star"></span>
                        </span>
                    </h2>
                    <a [routerLink]="['property', selectedHotel.title, selectedHotel.offerId]"
                        [queryParams]="{ checkInDate: requestForSearch.checkInDate, checkOutDate: requestForSearch.checkOutDate, adults: requestForSearch.adults, children: requestForSearch.children, or: requestForSearch.or, requestId: requestForSearch.requestId, hotelid: selectedHotel.offerId}">
                        <div class="imgWrap">
                            <div *ngIf="selectedHotel.pictures.length > 0" class="photo"
                                [ngStyle]="{ 'background-image' : 'url(' + selectedHotel.pictures[0].pictureThumbnailUrl + ')' }">
                            </div>
                            <div class="infoPrice"><span>From</span>{{selectedHotel.minPrice}}€</div>
                        </div>
                    </a>
                </div>
            </agm-info-window>
        </agm-marker>
    </agm-marker-cluster>
</agm-map>